export default class LogentryModel {
  constructor (data) {
    this.target = null

    this.values = {
      id: null,
      object_type_id: null,
      target_id: null,
      description: null,
      timestamp: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }

  getTitle () {
    return [this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null].join(' ')
  }
  getSubtitle () {
    return [this.values.description].join(' ')
  }
  getImage () {
    if (this.target && this.target.getImage) {
      return this.target.getImage()
    } else {
      return null
    }
  }
  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 4).toUpperCase()
    }

    return null
  }
  getCompareString () {
    let title = []

    if (this.values.timestamp) {
      title.push(this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null)
    }

    if (this.values.description) {
      title.push(this.values.description)
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/logentry/model/LogentryModel.js